module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#news",
      toString: function () {
        return this.url;
      }
    }